import script from "./ExportReceiptPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ExportReceiptPage.vue?vue&type=script&setup=true&lang=js"

import "./ExportReceiptPage.vue?vue&type=style&index=0&id=b8c5e65e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8c5e65e"]])

export default __exports__